var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('div',{staticClass:"head-inner"},[_c('div',[_c('div',[_vm._v("项目需求池")]),_c('p',{staticStyle:{"margin-top":"20px"}},[_vm._v("来这里让你的项目变得更简单")])]),_c('div',{staticStyle:{"padding-top":"28px"}},[_c('img',{attrs:{"src":require("../assets/images/headbg.png"),"alt":""}})])])])
}]

export { render, staticRenderFns }